__turbopack_context__.v({
  "chargerImage": "h2K7jG_chargerImage",
  "description": "h2K7jG_description",
  "heading": "h2K7jG_heading" + " " + __turbopack_context__.i(515534)["sectionHeading"],
  "mobileCard": "h2K7jG_mobileCard",
  "mobileCardsWrapper": "h2K7jG_mobileCardsWrapper",
  "section": "h2K7jG_section",
  "sequenceCanvas": "h2K7jG_sequenceCanvas",
  "sequenceWrapper": "h2K7jG_sequenceWrapper",
  "stickyContainer": "h2K7jG_stickyContainer",
  "textContainer": "h2K7jG_textContainer" + " " + __turbopack_context__.i(515534)["sectionTextBlock"],
});
